import { fetchApi } from './api';

// Fetch all merchants
export const getMerchants = async () => {
  return fetchApi('/merchants', { method: 'GET' });
};

// Create new merchant
export const createMerchant = async (merchantData) => {
  return fetchApi('/merchants', {
    method: 'POST',
    body: merchantData,
  });
};

// Update existing merchant
export const updateMerchant = async (id, merchantData) => {
  return fetchApi(`/merchants/${id}`, {
    method: 'PUT',
    body: merchantData,
  });
};

// Delete merchant
export const deleteMerchant = async (id) => {
  return fetchApi(`/merchants/${id}`, {
    method: 'DELETE',
  });
};
